import React from 'react';
import './styles.css';

const Header = ({ color }) => {
  const headerStyle = {
    borderBottomColor: color,
  };

  return (
    <header className="header-home" style={headerStyle}>
        <img src="/images/icone1.svg"  alt=''/>
        <span className="title-home">CONSULTA DE DOCUMENTOS DIGITAIS</span>
    </header>
  );
};

export default Header;
